// for doughnut chart
export const CHART_PERCENTAGE_ZERO = 0;
export const EMPTY_CHART_DATA = [-1, 0];
export const EMPTY_CHART_BACKGROUND = '#d8d8d8';
export const DEFAULT_ASSET_BACKGROUND = '#005FAC';
export const DEFAULT_BORROWING_BACKGROUND = '#FFB300';

export const ACCOUNT_TYPE_EMPTY = 'EMPTY';
export const ACCOUNT_TYPE_ASSET = 'ASSET';
export const ACCOUNT_TYPE_BORROWING = 'BORROWING';
